import { Model } from './typings.d'
import { requestErrorHandler } from '-/services'
import history from '-/utils/history'
import { convertGetUserInfoReturnDataToUser } from '-/utils/adapter'
import { setAuthority } from '-/utils/authority'
import { reloadAuthorized } from '-/utils/Authorized'
import { Dispatch } from '-/store/index'

import { getV1UserMe } from '-/apis'
import { postV1UserLogin, postV1UserLogout, postV1UserRegister } from '-/services/auth'
import { isPassword } from '-/utils/regex'

const initState = {
  loginFailed: false,
  loginFailedTimes: 0,
  errorMessage: '',
  captchaUrl: '',
  shouldVerifyByMessage: false,
  shouldModalConfirm: false,
}

const user: Model = {
  state: initState,
  reducers: {
    loginSuccess(state) {
      return {
        ...state,
        isLoginFailed: false,
      }
    },
    pharmacistLoginSuccess(state) {
      return {
        ...state,
        shouldVerifyByMessage: true,
      }
    },
    loginFailure(state, payload) {
      return {
        ...state,
        // loginFailedTimes: state.loginFailedTimes + 1,
        isLoginFailed: true,
        errorMessage: payload,
      }
    },
    getCaptchaSuccess(state, captchaUrl) {
      return {
        ...state,
        captchaUrl,
      }
    },
    toggleVerifyByMessage(state, enable) {
      return {
        ...state,
        shouldVerifyByMessage: enable,
      }
    },
    toggleModalConfirm(state, enable) {
      return {
        ...state,
        shouldModalConfirm: enable,
      }
    },
    resetState() {
      return {
        ...initState,
      }
    },
  },
  effects: (dispatch: Dispatch) => ({
    async login(payload) {
      try {
        // eslint-disable-next-line no-debugger
        // debugger;
        const {
          data: { sessionId },
        } = await postV1UserLogin(payload)
        // eslint-disable-next-line no-debugger
        // debugger;
        const { data } = await getV1UserMe()
      // eslint-disable-next-line no-debugger
      // debugger;
        const accountInfo = convertGetUserInfoReturnDataToUser(data)

        const isNeedChangePassword = !isPassword.test(payload.password)
        dispatch.account.setAccountInfo(accountInfo)
        window.localStorage.setItem('session-ID', String(sessionId))
        window.localStorage.setItem('isNeedChangePassword', String(isNeedChangePassword))

        setAuthority(accountInfo.permissionData)
        // eslint-disable-next-line no-debugger
        // debugger;
        reloadAuthorized()
        history.replace('/')
      } catch (err) {
        requestErrorHandler(err, {
          business: (code, msg) => {
            dispatch.auth.loginFailure(msg)
          },
        })
      }
    },
    async regist(payload) {
      try {
        const {
          data: { sessionId },
        } = await postV1UserRegister(payload)

        const { data } = await getV1UserMe()

        const accountInfo = convertGetUserInfoReturnDataToUser(data)

        dispatch.account.setAccountInfo(accountInfo)
        window.localStorage.setItem('session-ID', String(sessionId))

        setAuthority(accountInfo.permissionData)

        reloadAuthorized()
        history.replace('/')
      } catch (err) {
        requestErrorHandler(err, {
          business: (code, msg) => {
            dispatch.auth.loginFailure(msg)
          },
        })
      }
    },
    async logout(payload, rootState) {
      if (!rootState) return
      try {
        const sessionId = window.localStorage.getItem('session-ID')
        await postV1UserLogout({ sess: sessionId || '', platform: 'web' })
        setAuthority('')
        reloadAuthorized()
        dispatch.auth.loginFailure('')
        history.replace('/user')
      } catch (error) {
        requestErrorHandler(error)
      }
    },
  }),
}

export default user
